<template>
	<main>
		<banner :title="getText('tv3-title-short')"/>

		<section class="bg-gray-700">
			<div class="container mx-auto px-4 pb-16 md:pb-48">
				<div class="flex flex-wrap">
					<div class="text-left pt-12 w-full">
						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('tv3-title') }}</h2>
						</div>
						<div class="flex flex-wrap">
							<div class="w-full md:w-6/12">
								<div class="block mb-4">

									<p class="text-white font-semibold mb-4">{{ getText('tv3-address') }}</p>

									<p class="text-white font-semibold mb-4">{{ getText('client') }}: {{ getText('tv3-client')}}</p>

									<div class="text-white font-semibold">
										<p class="pb-4">{{ getText('collab') }}:</p>
										<ul>
											<li v-for="partner in partners" :key="partner">
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText(partner) }}</span>
											</li>
										</ul>
									</div>

									<div class="text-white font-semibold">
										<p class="text-white font-semibold mb-4 mt-4">{{ getText('object-data') }}</p>
										<ul>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('object-total-ground-area') }}: 12 340 m²</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('level-area') }}: 5 369 m²</span>
											</li>
											<li class="pl-4">
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('tv3-area-1') }}: 785 m²</span>
											</li>
											<li class="pl-4">
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('tv3-area-2') }}: 1 554 m²</span>
											</li>
											<li class="pl-4">
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('tv3-area-3') }}: 3 030 m²</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-12">
								<slider :images="slidesLnb"></slider>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
	import {TV3_PARTNERS} from '../../data/projectPartners'
	import {mapGetters} from "vuex";
	import Slider from '../../components/Slider.vue';
	import Banner from "../Banner";

	export default {
		name: "Tv3",
		data() {
			return {
				partners: TV3_PARTNERS,
				slidesLnb: [
					'/images/tv3/tv3-1.jpg',
					'/images/tv3/tv3-2.jpg',
				],
			}
		},
		computed: {
			...mapGetters(['getText'])
		},
		components: {
			Banner,
			Slider,
		},
	}
</script>